export default __webpack_public_path__ + "static/media/ukraine_flag.86ddf819.jpg";